/* ============================================================================
   facil. — MON DIAGNOSTIC (moteur du quiz). Vanilla, zéro lib.
   Scoring pondéré → algo de résultat (égalité, édition limitée, rupture,
   « je ne sais pas ») → soft gate email taggé → résultat + surprise + ajout
   panier pré-rempli. Mémoire navigateur (localStorage). DA facil.
   Données produit (handles/variant/prix/stock) lues depuis [data-dx-products]
   (rendu Liquid). Config questions/scoring ci-dessous (schématisée en phase 3).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilDx) return;
  window.__facilDx = true;

  var root = document.querySelector('[data-facil-dx]');
  if (!root) return;

  /* ---- Données produit (réelles, depuis Liquid) ---- */
  var PRODUCTS = {};
  try {
    var raw = root.querySelector('[data-dx-products]');
    if (raw) PRODUCTS = JSON.parse(raw.textContent);
  } catch (e) { PRODUCTS = {}; }
  var FORMATS = PRODUCTS.formats || {};

  /* ---- Méta modèles (noms wordmark + phrases = ALTO_Facil_Donnees_Produits.md) ---- */
  var MODELS = {
    MARRON:      { name: 'marron.',      phrase: 'La douceur. Pour les blondes, rousses et brunettes qui veulent intensifier leur regard, juste ce qu’il faut.', neighbor: 'NUDE',        limited: false, alt: null,     sizes: false },
    NUDE:        { name: 'nude.',        phrase: 'Tes cils en mieux. Une petite spike pour un effet légèrement destructuré, façon mascara look.',                 neighbor: 'SUBTIL',      limited: false, alt: null,     sizes: false },
    SUBTIL:      { name: 'subtil.',      phrase: 'Un look whispy qui réhausse le regard avec légèreté. Entre naturel et élégance.',                                neighbor: 'VOLUME',      limited: false, alt: null,     sizes: true  },
    VOLUME:      { name: 'volume.',      phrase: 'Un volume russe léger, grâce à la densité des bouquets. Un regard intense et soutenu qui ne passe pas inaperçu.', neighbor: 'SMOKY',       limited: false, alt: null,     sizes: true  },
    SMOKY:       { name: 'smoky.',       phrase: 'Un smoky eyes. Noir, pour un regard élégant sans être trop chargé.',                                              neighbor: 'SMOKY_BROWN', limited: true,  alt: 'VOLUME', sizes: false },
    SMOKY_BROWN: { name: 'smoky brown.', phrase: 'Un brown smoky eyes. Brun, pour un regard envoûtant sans être trop chargé.',                                       neighbor: 'SMOKY',       limited: true,  alt: 'MARRON', sizes: false }
  };
  var BESTSELLERS = ['MARRON', 'NUDE', 'VOLUME', 'SUBTIL', 'SMOKY', 'SMOKY_BROWN']; // ordre de priorité (départage)

  /* ---- Config questions + scoring (prompt). Phase 3 : exposer au schema. ---- */
  var QUESTIONS = [
    { id: 'teinte', title: 'La couleur qui te ressemble', options: [
      { label: 'Du brun, pour plus de douceur', why: 'Un brun tout en douceur', scores: { MARRON: 2, SMOKY_BROWN: 2 }, flags: { teinte: 'brun' } },
      { label: 'Du noir, classique',     why: 'Un noir classique',        scores: { NUDE: 1, SUBTIL: 1, VOLUME: 1, SMOKY: 1 }, flags: { teinte: 'noir' } },
      { label: 'Je ne sais pas encore',  why: null, scores: {}, idk: true }
    ]},
    { id: 'intensite', title: 'L’intensité que tu cherches', options: [
      { label: 'À peine là, naturel',     why: 'Un rendu à peine là, naturel', scores: { NUDE: 3, MARRON: 2 }, flags: { intensite: 'légère' } },
      { label: 'Visible mais élégant',    why: 'Un rendu visible mais élégant', scores: { SUBTIL: 3, SMOKY_BROWN: 2 }, flags: { intensite: 'moyenne' } },
      { label: 'Intense, tout en regard', why: 'Un regard intense', scores: { VOLUME: 3, SMOKY: 2 }, flags: { intensite: 'forte' } }
    ]},
    { id: 'style', title: 'Le style que tu vises', options: [
      { label: 'Effet mascara, mes cils en mieux',  why: 'Un effet mascara, tes cils en mieux', scores: { NUDE: 2 } },
      { label: 'Doux, juste rehaussé',              why: 'Un rendu doux, juste rehaussé',       scores: { MARRON: 2 } },
      { label: 'Whispy, légèrement destructuré',    why: 'Un effet whispy, destructuré',        scores: { SUBTIL: 2 } },
      { label: 'Volume russe, comme en institut',   why: 'Un volume russe, comme en institut',  scores: { VOLUME: 2 } },
      { label: 'Smoky, un regard profond',          why: 'Un smoky, un regard profond',         scores: { SMOKY: 2 }, scoresIf: { flag: 'teinte', value: 'brun', scores: { SMOKY_BROWN: 2 } } }
    ]},
    { id: 'oeil', title: 'La forme de ton œil', options: [
      { label: 'En amande',       why: 'Pour tes yeux en amande', scores: { SUBTIL: 2 } },
      { label: 'Rond',            why: 'Pour ouvrir ton regard',  scores: { VOLUME: 1, NUDE: 1 } },
      { label: 'Je ne sais pas',  why: null, scores: {}, idk: true }
    ]},
    { id: 'experience', title: 'Première fois ou habituée ?', options: [
      { label: 'C’est ma première fois', why: null, scores: {}, flags: { debutante: 'oui' } },
      { label: 'J’ai déjà posé',         why: null, scores: {}, flags: { debutante: 'non' } }
    ]}
  ];
  var WHY_PRIORITY = ['intensite', 'oeil', 'style', 'teinte']; // ordre des puces « pourquoi lui »

  /* ---- State ---- */
  var step = 0;                 // index question courante
  var answers = [];             // answers[qi] = optionIndex
  var STORE_KEY = 'facil_dx_result';

  /* ---- DOM ---- */
  var screens = {};
  Array.prototype.slice.call(root.querySelectorAll('[data-dx-screen]')).forEach(function (el) { screens[el.getAttribute('data-dx-screen')] = el; });
  var bar = root.querySelector('[data-dx-bar]');
  var fill = root.querySelector('[data-dx-fill]');
  var live = root.querySelector('[data-dx-live]');

  function show(name) {
    Object.keys(screens).forEach(function (k) {
      var on = k === name;
      screens[k].hidden = !on;
      screens[k].classList.toggle('is-active', on);
    });
    if (bar) bar.hidden = (name === 'intro' || name === 'result');
    if (live) live.textContent = name === 'question' ? ('Question ' + (step + 1) + ' sur ' + QUESTIONS.length) : '';
    var focusable = screens[name] && screens[name].querySelector('h1, h2, button, [tabindex]');
    if (focusable && name !== 'intro') { try { focusable.focus({ preventScroll: false }); } catch (e) {} }
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---- Calcul scores/flags/idk depuis les réponses (robuste au retour arrière) ---- */
  function compute() {
    var scores = {}, flags = {}, idk = 0;
    Object.keys(MODELS).forEach(function (k) { scores[k] = 0; });
    // passe 1 : flags
    answers.forEach(function (oi, qi) {
      if (oi == null) return;
      var opt = QUESTIONS[qi].options[oi];
      if (opt.flags) Object.keys(opt.flags).forEach(function (f) { flags[f] = opt.flags[f]; });
    });
    // passe 2 : scores (+ conditionnels) + idk
    answers.forEach(function (oi, qi) {
      if (oi == null) return;
      var opt = QUESTIONS[qi].options[oi];
      if (opt.idk) idk++;
      if (opt.scores) Object.keys(opt.scores).forEach(function (m) { scores[m] += opt.scores[m]; });
      if (opt.scoresIf && flags[opt.scoresIf.flag] === opt.scoresIf.value) {
        Object.keys(opt.scoresIf.scores).forEach(function (m) { scores[m] += opt.scoresIf.scores[m]; });
      }
    });
    return { scores: scores, flags: flags, idk: idk };
  }

  function intensityPreferred(intensite) {
    if (intensite === 'légère') return ['NUDE', 'MARRON'];
    if (intensite === 'moyenne') return ['SUBTIL', 'SMOKY_BROWN'];
    if (intensite === 'forte') return ['VOLUME', 'SMOKY'];
    return [];
  }

  /* ---- Algorithme de résultat (prompt §4 + doc §5) ---- */
  function resolve(c) {
    var scores = c.scores;
    var sorted = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
    var max = scores[sorted[0]];
    var second = scores[sorted[1]] != null ? scores[sorted[1]] : 0;
    var tied = sorted.filter(function (k) { return scores[k] === max; });

    var bestsellerFallback = false;
    var winner;

    if (c.idk >= 2 && (max - second) < 2) {
      // garde-fou « tout je ne sais pas » → best-sellers
      winner = 'MARRON';
      bestsellerFallback = true;
    } else if (tied.length === 1) {
      winner = tied[0];
    } else {
      // départage : a) cohérence intensité, b) best-seller (inclut la logique « voisin »)
      var pref = intensityPreferred(c.flags.intensite).filter(function (k) { return tied.indexOf(k) !== -1; });
      if (pref.length) {
        winner = pref[0];
      } else {
        winner = BESTSELLERS.filter(function (k) { return tied.indexOf(k) !== -1; })[0] || tied[0];
      }
    }

    var rawWinner = winner;
    var limited = MODELS[winner].limited;
    var altKey = MODELS[winner].alt; // alternative permanente (édition limitée)

    // Rupture de stock → bascule (édition limitée : alt permanente d'abord, sinon voisins)
    var soldout = false;
    if (PRODUCTS[winner] && PRODUCTS[winner].available === false) {
      soldout = true;
      winner = ensureAvailable(winner);
      limited = MODELS[winner].limited;
      altKey = MODELS[winner].alt;
    }

    return {
      winner: winner,
      rawWinner: rawWinner,
      limited: limited,
      altKey: altKey,
      soldout: soldout,
      bestsellerFallback: bestsellerFallback,
      debutante: c.flags.debutante || 'non',
      intensite: c.flags.intensite || '',
      teinte: c.flags.teinte || '',
      sizes: MODELS[winner].sizes,
      whys: buildWhys()
    };
  }

  function ensureAvailable(key) {
    if (PRODUCTS[key] && PRODUCTS[key].available) return key;
    if (MODELS[key].limited && MODELS[key].alt && PRODUCTS[MODELS[key].alt] && PRODUCTS[MODELS[key].alt].available) return MODELS[key].alt;
    var seen = {}, cur = key;
    for (var i = 0; i < 6; i++) {
      cur = MODELS[cur].neighbor;
      if (seen[cur]) break;
      seen[cur] = 1;
      if (PRODUCTS[cur] && PRODUCTS[cur].available) return cur;
    }
    return 'MARRON';
  }

  function buildWhys() {
    var out = [];
    WHY_PRIORITY.forEach(function (qid) {
      if (out.length >= 3) return;
      var qi = -1;
      QUESTIONS.forEach(function (q, i) { if (q.id === qid) qi = i; });
      if (qi < 0 || answers[qi] == null) return;
      var why = QUESTIONS[qi].options[answers[qi]].why;
      if (why) out.push(why);
    });
    return out;
  }

  /* ---- Rendu d'une question ---- */
  function renderQuestion() {
    var q = QUESTIONS[step];
    screens.question.querySelector('[data-dx-qcount]').textContent = 'Question ' + (step + 1) + ' / ' + QUESTIONS.length;
    screens.question.querySelector('[data-dx-qtitle]').textContent = q.title;
    var wrap = screens.question.querySelector('[data-dx-options]');
    wrap.innerHTML = '';
    q.options.forEach(function (opt, oi) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'facil-dx__option';
      b.setAttribute('data-i', oi);
      if (answers[step] === oi) b.classList.add('is-selected');
      b.innerHTML = '<span class="facil-dx__option-label"></span>';
      b.querySelector('.facil-dx__option-label').textContent = opt.label;
      b.addEventListener('click', function () { choose(oi); });
      wrap.appendChild(b);
    });
    var back = screens.question.querySelector('[data-dx-back]');
    back.hidden = step === 0;
    if (fill) fill.style.width = (step / QUESTIONS.length * 100) + '%';
    show('question');
  }

  function choose(oi) {
    answers[step] = oi;
    if (step < QUESTIONS.length - 1) {
      step++;
      renderQuestion();
    } else {
      if (fill) fill.style.width = '100%';
      // Résultat affiché ; l'offre -10% reste GATÉE derrière l'email (invitation par défaut).
      currentResult = resolve(compute());
      showResult(currentResult, false);
    }
  }

  /* ---- Soft gate ---- */
  var currentResult = null;
  function goGate() {
    currentResult = resolve(compute());
    var nameEl = screens.gate.querySelector('[data-dx-gate-name]');
    if (nameEl) nameEl.textContent = MODELS[currentResult.winner].name;
    show('gate');
  }

  function tagsString(r) {
    return ['newsletter', 'quiz', 'quiz_result:' + r.winner, 'intensite:' + (r.intensite || 'na'), 'teinte:' + (r.teinte || 'na'), 'debutante:' + r.debutante].join(', ');
  }

  /* Écouteur DÉLÉGUÉ sur la racine (le submit remonte) : capte le formulaire email quel que
     soit son id / son timing de rendu → on empêche TOUJOURS le rechargement natif de la page. */
  /* Filet de sécurité : si un <form> apparaît un jour dans le quiz, on l'empêche de recharger. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.tagName === 'FORM' && f.closest && f.closest('[data-facil-dx]')) e.preventDefault();
  }, true);

  /* ---- Envoi de l'email : 100% JS, AUCUN <form> (cf. commentaire dans la section).
     Fire-and-forget : le code se débloque quoi qu'il arrive côté réseau. ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-dx-offer-submit]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var wrap = btn.closest('[data-dx-offer-form]');
    var scope = btn.closest('[data-facil-dx]');
    var input = wrap && wrap.querySelector('input[type="email"]');
    var errEl = wrap && wrap.querySelector('[data-dx-offer-error]');
    var email = input ? String(input.value).trim() : '';

    /* Validation minimale côté client (il n'y a plus de validation native de formulaire). */
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      if (errEl) errEl.hidden = false;
      if (input) input.focus();
      return;
    }
    if (errEl) errEl.hidden = true;

    try {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', currentResult ? tagsString(currentResult) : 'newsletter, quiz');
      fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
    } catch (err) {}

    revealCode(scope);
  });

  /* Débloque le code : masque l'invitation, révèle le bloc code, mémorise l'état. */
  function revealCode(scope) {
    /* scope = l'instance du quiz qui a réellement soumis (sécurise le cas multi-instances). */
    var ctx = scope || screens.result;
    var surprise = ctx.querySelector('[data-dx-surprise]');
    var gate = ctx.querySelector('[data-dx-offer-gate]');
    if (surprise) surprise.hidden = false;
    if (gate) gate.hidden = true;
    if (live) live.textContent = 'Ton code de bienvenue est débloqué.';
    if (currentResult) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify({ r: currentResult, surprise: true, ts: Date.now() })); } catch (e) {}
    }
  }
  var skip = root.querySelector('[data-dx-skip]');
  if (skip) skip.addEventListener('click', function () { showResult(currentResult, false); });

  /* ---- Écran résultat ---- */
  function el(sel) { return screens.result.querySelector(sel); }
  function showResult(r, withSurprise) {
    if (!r) return;
    var m = MODELS[r.winner];
    var p = PRODUCTS[r.winner] || {};

    el('[data-dx-r-name]').textContent = m.name;
    el('[data-dx-r-phrase]').textContent = m.phrase;
    el('[data-dx-r-limited]').hidden = !r.limited;

    // Pourquoi lui
    var why = el('[data-dx-r-why]');
    why.innerHTML = '';
    var whys = r.whys || [];
    if (r.bestsellerFallback) whys = ['Notre best-seller, sûr et polyvalent'].concat(whys);
    whys.slice(0, 3).forEach(function (w) {
      var li = document.createElement('li');
      li.className = 'facil-dx__r-why-item';
      li.textContent = w;
      why.appendChild(li);
    });

    // Offre -10% : code débloqué (withSurprise) OU invitation email (défaut).
    el('[data-dx-surprise]').hidden = !withSurprise;
    var offerGate = el('[data-dx-offer-gate]');
    if (offerGate) offerGate.hidden = !!withSurprise;

    // Format recommandé + CTA
    renderFormat(r, p);

    // Mémoire navigateur
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ r: r, surprise: withSurprise, ts: Date.now() })); } catch (e) {}

    show('result');
  }

  function renderFormat(r, p) {
    var fmt = el('[data-dx-format]');
    var cta = el('[data-dx-cta]');
    var m = MODELS[r.winner];
    fmt.innerHTML = '';
    cta.innerHTML = '';

    var sizeLine = r.sizes ? '<p class="facil-dx__format-size">Tailles 10, 12 et 14 aussi sur la fiche.</p>' : '';
    function thumb(src, label) {
      if (!src) return '';
      return '<figure class="facil-dx__format-thumb"><img src="' + src + '" alt="" loading="lazy"><figcaption>' + escapeHtml(label) + '</figcaption></figure>';
    }

    if (r.debutante === 'oui') {
      // Débutante → LA BASE (boîte du modèle + pince)
      var lb = FORMATS.la_base || {};
      var imgsA = thumb(p.img, m.name) + thumb(FORMATS.pince_img, 'pince précision');
      fmt.innerHTML =
        '<p class="facil-dx__format-eyebrow">Le format pour toi</p>' +
        '<h3 class="facil-dx__format-title">LA BASE</h3>' +
        (imgsA ? '<div class="facil-dx__format-imgs">' + imgsA + '</div>' : '') +
        '<p class="facil-dx__format-body">Ta boîte + la pince précision. Livraison offerte.</p>' +
        sizeLine;
      cta.innerHTML =
        '<a class="button btn-dir facil-dx__cta-primary" href="' + (lb.url || '/products/la-base') + '">Découvrir LA BASE</a>' +
        '<a class="facil-dx__cta-secondary" href="' + (p.url || '/collections/cils') + '">ou juste la boîte ' + escapeHtml(m.name) + '</a>';
    } else {
      // Habituée → boîte seule MIXTE (+ COMPOSE en upgrade)
      var imgsB = thumb(p.img, m.name);
      fmt.innerHTML =
        '<p class="facil-dx__format-eyebrow">Le format pour toi</p>' +
        '<h3 class="facil-dx__format-title">Ta boîte ' + escapeHtml(m.name) + ' <span class="facil-dx__format-size-tag">taille MIXTE</span></h3>' +
        (imgsB ? '<div class="facil-dx__format-imgs">' + imgsB + '</div>' : '') +
        '<p class="facil-dx__format-body">La plus polyvalente. Envie de varier ? COMPOSE TON REGARD : 4 boîtes, 1 offerte.</p>' +
        sizeLine;
      var addLabel = 'Ajouter ' + m.name + ' à mon panier' + (p.price ? ' · ' + p.price : '');
      cta.innerHTML =
        '<button type="button" class="button btn-dir facil-dx__cta-primary" data-dx-add="' + (p.variant || '') + '"' + (p.available ? '' : ' disabled') + '>' + escapeHtml(addLabel) + '</button>' +
        '<a class="facil-dx__cta-secondary" href="' + ((FORMATS.compose && FORMATS.compose.url) || '/products/compose-ton-regard') + '">Voir COMPOSE TON REGARD</a>';
    }

    // Alternative édition limitée (permanente)
    if (r.limited && r.altKey && MODELS[r.altKey]) {
      var note = document.createElement('p');
      note.className = 'facil-dx__format-alt';
      note.innerHTML = 'Édition limitée. Alternative permanente la plus proche : ' + escapeHtml(MODELS[r.altKey].name);
      fmt.appendChild(note);
    }

    var addBtn = cta.querySelector('[data-dx-add]');
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn.getAttribute('data-dx-add')); });
  }

  function addToCart(variantId) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function () { window.location.href = '/cart'; })
      .catch(function () { window.location.href = '/cart'; });
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---- Copier le code promo (clic → presse-papier) ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-dx-copy]');
    if (!btn) return;
    /* Le clic « Copier » ne doit RIEN déclencher d'autre : ni les handlers globaux
       (ouverture/fermeture), ni le clic-fond de la fenêtre → le quiz reste ouvert. */
    e.preventDefault();
    e.stopPropagation();
    var code = btn.getAttribute('data-dx-copy') || '';
    var hint = btn.querySelector('.facil-dx__surprise-copy');
    function done() {
      if (!hint) return;
      hint.textContent = 'Copié !';
      btn.classList.add('is-copied');
      setTimeout(function () { hint.textContent = 'Copier'; btn.classList.remove('is-copied'); }, 1800);
    }
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        /* On insère le champ DANS le quiz : hors d'un <dialog> modal le reste du document
           est « inert », le focus s'échapperait de la fenêtre (et la refermerait). */
        (btn.parentNode || root).appendChild(ta); ta.focus(); ta.select();
        document.execCommand('copy'); ta.remove(); done();
      } catch (err) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(fallback);
    } else { fallback(); }
  });

  /* ---- Navigation ---- */
  var startBtn = root.querySelector('[data-dx-start]');
  if (startBtn) startBtn.addEventListener('click', function () { step = 0; answers = []; renderQuestion(); });
  var backBtn = root.querySelector('[data-dx-back]');
  if (backBtn) backBtn.addEventListener('click', function () { if (step > 0) { step--; renderQuestion(); } });
  var restart = root.querySelector('[data-dx-restart]');
  if (restart) restart.addEventListener('click', function () { try { localStorage.removeItem(STORE_KEY); } catch (e) {} step = 0; answers = []; renderQuestion(); });

  /* ---- Mémoire : visiteuse qui revient ---- */
  try {
    var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
    if (saved && saved.r && MODELS[saved.r.winner]) {
      var restore = root.querySelector('[data-dx-restore]');
      if (restore) {
        restore.hidden = false;
        restore.addEventListener('click', function () { currentResult = saved.r; showResult(saved.r, !!saved.surprise); });
      }
    }
  } catch (e) {}

  /* ---- Mode modal (accueil) : le quiz s'ouvre en fenêtre depuis un déclencheur
     [data-dx-open]. Fermeture : croix, clic backdrop, Échap (natif <dialog>).
     Absent (page dédiée) → le déclencheur garde son comportement de lien. ---- */
  var modal = document.querySelector('[data-facil-dx-modal]');
  if (modal) {
    var openModal = function () {
      if (typeof modal.showModal === 'function') { if (!modal.open) modal.showModal(); }
      else { modal.setAttribute('open', ''); }
    };
    var closeModal = function () {
      if (typeof modal.close === 'function' && modal.open) modal.close();
      else modal.removeAttribute('open');
    };
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var closer = e.target.closest('[data-dx-modal-close]');
      if (closer) { e.preventDefault(); closeModal(); return; }
      /* Tout déclencheur explicite OU tout lien de page contenant « diagnostic » (nav, hero, teaser). */
      var opener = e.target.closest('[data-dx-open], a[href*="/pages/"][href*="diagnostic"]');
      if (opener) { e.preventDefault(); openModal(); }
    });
    /* Clic sur le fond (hors panneau) ferme. */
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  }
})();
